import React, { useState, useRef } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image';
import IcoPlayPodcast from '../../../assets/images/ico-play-podcast.svg'
import IcoPausePodcast from '../../../assets/images/ico-pause-podcast.svg'
import IcoMic from '../../../assets/images/ico_mic.svg'
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import './single-podcast.scss'

const SinglePodcast = ({ info }) => {

    const player = useRef();
    const [play, setPlay] = useState(false);

    return (
        <div className="f-m-single-podcast">
            <div className="f-m-single-podcast__background"></div>
            <div className="f-m-single-podcast__type">
                <img
                    src={IcoMic}
                    alt="ico mic"
                />
                <p>PODCAST</p>
            </div>
            <div className="f-m-single-podcast__content">
                <div className="f-m-single-podcast__resource-container">
                    {info.imagen && info.imagen[0] &&
                        <GatsbyImage
                            className="f-m-single-podcast__image"
                            image={info.imagen[0].gatsbyImageData}
                            alt={info.imagen[0].description}
                        />
                    }
                </div>
                <div className="f-m-single-podcast__information">
                    <h1 className="f-m-single-podcast__title">{info.tituloGeneral}</h1>
                </div>
                <div className={"f-m-single-podcast__player-container"}>
                    <div className="f-m-single-podcast__player">
                        {!play ?
                            <img
                                src={IcoPlayPodcast}
                                alt="ico-play-podcast"
                                className="f-m-single-podcast__play-icon"
                                onClick={() => {
                                    setPlay(true)
                                    player.current.audio.current.play()
                                }}
                            />
                            :
                            <img
                                src={IcoPausePodcast}
                                alt="ico-play-podcast"
                                className="f-m-single-podcast__play-icon"
                                onClick={() => {
                                    setPlay(false)
                                    player.current.audio.current.pause()
                                }}
                            />
                        }
                    </div>
                    <div className="f-m-single-podcast__player-progress">
                        <AudioPlayer
                            src={info.imagen[1].file.url}
                            showJumpControls={false}
                            ref={player}
                            customProgressBarSection={[
                                RHAP_UI.PROGRESS_BAR
                            ]}
                            customControlsSection={[
                                RHAP_UI.CURRENT_TIME,
                                RHAP_UI.CURRENT_LEFT_TIME,
                            ]}
                            onPlay={() => { setPlay(true) }}
                            onPause={() => { setPlay(false) }}
                            showDownloadProgress={false}
                            className={"f-m-single-podcast__audio-player"}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SinglePodcast
